// API Endpoints
export const API_ENDPOINTS = {
  PRODUCT: '/product',
  RELEASE_NOTES: '/release-notes',
};

// Release note statuses
export enum RELEASE_NOTE_STATUS {
  Draft = 'Draft',
  Hotfix = 'Hotfix',
}

// Special version string for drafts
export const NEXT_RELEASE_VERSION = 'Next Release';

export const MODAL_STATES = {
  NONE: 'none',
  CONFIRM: 'confirm',
  ERROR: 'error',
} as const;

export type TModalState = typeof MODAL_STATES[keyof typeof MODAL_STATES];

export const RELEASE_NOTE_TYPE = {
  STANDARD: 'standard',
  DRAFT: 'draft',
} as const;

export type TReleaseNoteType = typeof RELEASE_NOTE_TYPE[keyof typeof RELEASE_NOTE_TYPE];

export const SELECT_RELEASE_NOTE = 'SELECT_RELEASE_NOTE';

export const VISIBILITY_SCOPE = {
  ALL: 'all',
  INTERNAL: 'internal',
  BETA: 'beta',
} as const;

export const RELEASED_NOTES_TYPES = {
  SCHEDULED_RELEASE: 'scheduledRelease',
  HOTFIX: 'hotfix',
} as const;
